import { Alert, Button, Space, Typography, Flex, Avatar } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const NoAccessAlertUpgradePlan = ({ 
  title = 'Access Limited', 
  message = 'please upgrade your plan or contact your administrator to access this feature', 
  upgrade = false
}) => {
  const { Text, Title } = Typography;
  return (
    <Alert
      type="warning"
      showIcon={true}
      icon={<ExclamationCircleOutlined className='fs-6' style={{ color: '#faad14' }} />}
      title={
        <div>
          <Flex justify="space-between">
          <Flex className='flex-grow-1 ms-3' vertical align="flex-start" justify="space-between">
            <Title className='mb-0 mt-0' level={3}>
              {title}
            </Title>
            <Text>
              {message}
            </Text>
            {upgrade ? 
              <Button type="primary" onClick={() => history.push('/licenses')}>
                Upgrade Your Plan
              </Button>
            : null}
          </Flex>
          </Flex>
        </div>
      } 
      banner
      style={{
        padding: '12px 16px',
        marginBottom: 16,
      }}
    />
  );
};

export default NoAccessAlertUpgradePlan;
